import { LeadCurd } from "./leadCrud";

export default function SaleLeads() {
  return <LeadCurd name="我的客户" type="new" router="saleNewLeads" />;
}
